import React from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from 'src/routes/PrivateRoute';
import { CampaignConfigBuilderPage } from '../pages';

export const routes = (
  <>
    <Route
      path="/campaign-config-builder/:configId?"
      element={
        <PrivateRoute>
          <CampaignConfigBuilderPage />
        </PrivateRoute>
      }
    />
  </>
);
